// Styling for all the buttons in this component, so they feel more tactile
export const buttonStyling = `
    active:vai-scale-95 
    vai-transition-all 
    vai-duration-150 
    hover:vai-shadow-lg 
    hover:vai-ring-2 
    hover:vai-ring-offset-2
  `;
